import CollapsableMenu from 'components/containers/CollapsableMenu';
import useUserDocuments from 'hooks/requests/user/hooks/useUserDocuments';
import ProfileDocumentsEmpty from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsEmpty';
import { createInvestmentsItems } from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsInvestments/utils';
import ProfileDocumentsLoading from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsLoading';
import React from 'react';
import { DocumentGroupName } from 'types/documents-types';
import { getSubscriptionDocuments } from 'utils/documents_utils';

const ProfileDocumentsInvestments = () => {
  const { userDocuments, loading } = useUserDocuments();
  const multiInvestments = getSubscriptionDocuments(
    DocumentGroupName.INVESTMENT_DOCUMENTS,
    userDocuments
  );
  const investmentsItems = createInvestmentsItems(multiInvestments);

  if (loading) {
    return <ProfileDocumentsLoading />;
  }

  if (investmentsItems.length === 0) {
    return <ProfileDocumentsEmpty />;
  }

  return <CollapsableMenu items={investmentsItems} />;
};

export default ProfileDocumentsInvestments;
